import { Props_SnippetPride } from './Pride.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SharedHeading from "../Shared/Heading/Heading";

const SnippetPride = (props: Props_SnippetPride) => {
    const { heading, content, repeatable_entry } = props

    const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';

    return (
    <section className="snippet-pride">
        <div className={`snippet-pride__container`}>
            <div className="snippet-pride__container-content">
                <SharedHeading
                    className="snippet-pride__heading"
                    alignment={
                        heading.alignment?.value === "start" ||
                        heading.alignment?.value === "center" ||
                        heading.alignment?.value === "end"
                            ? heading.alignment.value
                            : undefined
                    }
                    visibility={typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'}
                    level={headingLevel}
                >
                    {heading.text?.value}
                </SharedHeading>
                { content.content?.value && (
                    <div className="snippet-pride__content">
                        {CompileMarkdown(content.content.value)}
                    </div>
                )}
            </div>
            <div className="snippet-pride__container-entries">
            { repeatable_entry.map((entry, index: number) => (
                <div key={index} className={`snippet-pride__entry`}>
                    { entry.image?.value && (
                        <figure className="snippet-pride__entry-image-container">
                            <img
                                className="snippet-pride__entry-image"
                                loading="lazy"
                                height={180}
                                width={180}
                                src={entry.image.value}
                                alt={entry.alt?.value ? entry.alt.value : ''}
                            />
                        </figure>
                    )}
                    { entry.heading?.value && (
                        <h3 className="snippet-pride__entry-heading">{ entry.heading.value }</h3>
                    )}
                    { entry.content?.value && (
                        <div className="snippet-pride__entry-content">{CompileMarkdown(entry.content.value)}</div>
                    )}
                </div>
            ))}
            </div>
        </div>
    </section>
    )
}

export default SnippetPride